import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MiscellaneousServicesOutlinedIcon from "@mui/icons-material/MiscellaneousServicesOutlined";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import VolunteerActivismOutlinedIcon from "@mui/icons-material/VolunteerActivismOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import ColorLensOutlinedIcon from "@mui/icons-material/ColorLensOutlined";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import PinOutlinedIcon from "@mui/icons-material/PinOutlined";
import HistoryToggleOffOutlinedIcon from "@mui/icons-material/HistoryToggleOffOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

export const getPages = (userData) => [
  {
    title: "Opis aplikacji",
    path: "/description",
    icon: <InfoOutlinedIcon fontSize="small" />,
  },
  {
    title: "Usługi",
    path: "/services",
    icon: <MiscellaneousServicesOutlinedIcon fontSize="small" />,
  },

  ...(userData?.userId
    ? [
        {
          title: "Opiekunki",
          path: "/list",
          icon: <FavoriteBorderIcon fontSize="small" />,
        },
        {
          title: "Mój profil",
          path: "/profile",
          icon: <AccountCircleOutlinedIcon fontSize="small" />,
        },
        {
          title: "Testy poznawcze",
          icon: <PsychologyOutlinedIcon fontSize="small" />,
          children: [
            {
              title: "Test Stroopa",
              path: "/stroop-test",
              icon: <ColorLensOutlinedIcon fontSize="small" />,
            },
            {
              title: "Test Pamięci - karty",
              path: "/memory-test",
              icon: <GridViewOutlinedIcon fontSize="small" />,
            },
            {
              title: "Test Pamięci - liczby",
              path: "/number-test",
              icon: <PinOutlinedIcon fontSize="small" />,
            },
            {
              title: "Trening mózgu - 2 wstecz",
              path: "/back-test",
              icon: <HistoryToggleOffOutlinedIcon fontSize="small" />,
            },
            {
              title: "Pamięć i szybkie czytanie",
              path: "/word-test",
              icon: <MenuBookOutlinedIcon fontSize="small" />,
            },
          ],
        },
        {
          title: "Świadczenie wspierające",
          path: "/swiadczenie-wspierajace",
          icon: <VolunteerActivismOutlinedIcon fontSize="small" />,
        },
      ]
    : [
        {
          title: "Testy poznawcze",
          icon: <PsychologyOutlinedIcon fontSize="small" />,
          children: [
            {
              title: "Test Stroopa",
              path: "/stroop-test",
              icon: <ColorLensOutlinedIcon fontSize="small" />,
            },
            {
              title: "Test Pamięci - karty",
              path: "/memory-test",
              icon: <GridViewOutlinedIcon fontSize="small" />,
            },
            {
              title: "Test Pamięci - liczby",
              path: "/number-test",
              icon: <PinOutlinedIcon fontSize="small" />,
            },
            {
              title: "Trening mózgu - 2 wstecz",
              path: "/back-test",
              icon: <HistoryToggleOffOutlinedIcon fontSize="small" />,
            },
            {
              title: "Pamięć i szybkie czytanie",
              path: "/word-test",
              icon: <MenuBookOutlinedIcon fontSize="small" />,
            },
          ],
        },
        {
          title: "Świadczenie wspierające",
          path: "/swiadczenie-wspierajace",
          icon: <VolunteerActivismOutlinedIcon fontSize="small" />,
        },
        {
          title: "FAQ",
          path: "/faq",
          icon: <HelpOutlineIcon fontSize="small" />,
        },
      ]),
];
